import React from 'react';

interface CanvasProps {
  globalCompositeOperation?: GlobalCompositeOperation;
  onCanvasInited?: (canvas: HTMLCanvasElement) => void;
  onResize?: (width: number, height: number) => void;
  onMouseDown?: (e: React.MouseEvent<HTMLCanvasElement>) => void;
  onMouseMove?: (e: React.MouseEvent<HTMLCanvasElement>) => void;
  onMouseUp?: (e: React.MouseEvent<HTMLCanvasElement>) => void;
}

export default class Canvas extends React.Component<CanvasProps> {
  private canvasRef = React.createRef<HTMLCanvasElement>();
  private resize!: () => void;

  componentDidMount() {
    this.initCanvas();
    this.resize = this.handleResize.bind(this);
    window.addEventListener('resize', this.resize);
  }

  initCanvas() {
    const canvas = this.canvasRef.current;
    if (!canvas) return;
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    if (this.props.globalCompositeOperation) {
      const context = canvas.getContext('2d');
      if (context) context.globalCompositeOperation = this.props.globalCompositeOperation;
    }

    this.props.onCanvasInited?.(canvas);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  handleResize() {
    const canvas = this.canvasRef.current;
    if (!canvas) return;
    const width = window.innerWidth;
    const height = window.innerHeight;
    canvas.width = width;
    canvas.height = height;
    this.props.onResize?.(width, height);
  }

  render() {
    return (
      <div>
        <canvas
          ref={this.canvasRef}
          onMouseDown={this.props.onMouseDown}
          onMouseMove={this.props.onMouseMove}
          onMouseUp={this.props.onMouseUp}
          className="canvas"
        />
      </div>
    );
  }
}
